export const EMPTY_OBJECT = Object.freeze( {} );
export const EMPTY_ARRAY = Object.freeze( [] );

const wpAdminThemeColorRgb = '#3858e9';
const wpAdminThemeColor = `var(--wp-admin-theme-color, ${ wpAdminThemeColorRgb })`;
const wpAdminThemeColorDarker10 = 'var(--wp-admin-theme-color, #2145e6)';
const wpComponentsColorAccent = `var(--wp-components-color-accent, ${ wpAdminThemeColor })`;

export const COLORS = {
	nabText: '#1e1e1e',
	nabTextInverted: '#fff',
	nabTextLightGrey: '#949494',
	nabTextDarkGrey: '#757575',
	nabTextGreen: '#070',
	nabTextRed: '#cc1818',
	nabTextShadow: '1px 1px 1px rgba(0, 0, 12, 0.6)',

	nabBackgroundBlack: '#23282d',
	nabBackgroundWhite: '#fff',
	nabBackgroundLightGrey: '#f3f4f5',
	nabBackgroundDarkGrey: '#d2d2d2',
	nabBackgroundMetalBlue: '#8298b3',
	nabBackgroundGreen: '#58b462',
	nabBackgroundOrange: '#e28f25',
	nabBackgroundRed: '#f43f27',
	nabBackgroundBlackTranslucent: 'rgba(0, 0, 12, 0.8)',
	nabBackgroundDefaultImage: 'rgba(0, 0, 12, 0.1)',

	nabBoxShadow: 'rgba(0, 0, 40, 0.07)',

	nabBorder: '#7e8993',
	nabBorderLight: '#e2e4e7',
	nabBorderLighter: '#f1f1f1',

	nabBackgroundAlternativeA: '#2a2a3f',
	nabBackgroundAlternativeB: '#d24633',
	nabBackgroundAlternativeC: '#4f97c5',
	nabBackgroundAlternativeD: '#64ab64',
	nabBackgroundAlternativeE: '#ff9000',
	nabBackgroundAlternativeF: '#60609f',

	wpAdminThemeColor,
	wpAdminThemeColorRgb,
	wpAdminThemeColorDarker10,
	wpComponentsColorAccent,
};
